import axios from "axios";
// import history from "../Helper/history";
// import { useNavigate  } from 'react-router-dom';

// Common get API
export const GetService = async (url, params) => {
  const token = localStorage.getItem("Atoken");

  if (!url) {
    return;
  }

  const axiosConfig = {
    headers: {
      Accept: "application/json",
      'x-access-token': token,
    },
    ...params,
  };

  try {
    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      Signout()
      // localStorage.removeItem("Atoken"); 
      // // history.push("/login");
      // window.location.reload()  
    }
    return error.response;
  }
};

function Signout() {
  const retainedValue = localStorage.getItem('AdminData');
  localStorage.clear();
  if (retainedValue !== null) {
    localStorage.setItem('AdminData', retainedValue);
  }
  window.location.reload() 
}

// Common Post API for JSON post
export const PostService = async (url, data) => {
  // const history1 = useNavigate ();
  const token = localStorage.getItem("Atoken");

  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      'x-access-token': token,
    },
  };

  try {
    const response = await axios.post(url, data, axiosConfig);
    // console.log(response) 
    return response;
  } catch (error) {  
    if (error.response.status === 401) {
      Signout()
      // localStorage.removeItem("Atoken"); 
      // // history.push("/login");
      // window.location.reload()  
    }
    return error.response;
  }
};


// Common Post API for FormData post
export const PostFormData = async (url, data) => {
  const token = localStorage.getItem("Atoken");

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      'x-access-token': token,
    },
  };

  try {
    const response = await axios.post(url, data, axiosConfig); 
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      Signout()
      // localStorage.removeItem("Atoken"); 
      // // history.push("/login");
      // window.location.reload()  
    }
    return error.response;
  }
};


// Common Put API
export const PutService = async (url, data) => {
    const token = localStorage.getItem('Atoken');
  
    const axiosConfig = {
      headers: {
        'Content-Type': "application/json",
        Authorization: token,
      },
    };
  
    try {
      const response = await axios.put(url, data, axiosConfig); 
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        Signout()
        // localStorage.removeItem("Atoken"); 
        // // history.push("/login");
        // window.location.reload()  
      }
      return error.response;
    }
  };
  
  // Common Put API for FormData
  export const PutFormData = async (url, data) => {
    const token = localStorage.getItem('Atoken');
  
    const axiosConfig = {
      headers: {
        'Content-Type': "multipart/form-data",
        Authorization: token,
      },
    };
  
    try {
      const response = await axios.put(url, data, axiosConfig); 
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        Signout()
        // localStorage.removeItem("Atoken"); 
        // // history.push("/login");
        // window.location.reload()  
      }
      return error.response;
    }
  };
  
  // Common Delete API
  export const DeleteService = async (url, params) => {
    const token = localStorage.getItem('Atoken');
  
    const axiosConfig = {
      headers: {
        Accept: "application/json",
        Authorization: token,
      },
      ...params,
    };
  
    try {
      const response = await axios.delete(url, axiosConfig); 
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        Signout()
        // localStorage.removeItem("Atoken"); 
        // // history.push("/login");
        // window.location.reload()  
      }
      return error.response;
    }
  };

  export const handleNumberChange = (e) => {
    const value = e.target.value;
    // Regular expression to allow only numbers
    const regex = /^[0-9\b]+$/;
    console.log(regex.test(value))

    if (value === '' && regex.test(value)) {
      return true
    }else{
      return false
    }
  };
  